
export async function guestGetChecking(ladingCode: string, recaptchaToken: string){
    let url = process.env.VUE_APP_BASE_API
    url = url?.toString().replace("api", "guest")
    return fetch(url + `checkings?ladingCode=` + ladingCode + '&captchaToken=' + recaptchaToken, {
        method: 'GET',
        headers: new Headers(
            {
                'Content-Type': 'application/json',
            }
        )
    })
}

export async function guestGetTracking(ladingCode: string, recaptchaToken: string){
    let url = process.env.VUE_APP_BASE_API
    url = url?.toString().replace("api", "guest")
    return fetch(url + `tracking?ladingCode=` + ladingCode + '&captchaToken=' + recaptchaToken, {
        method: 'GET',
        headers: new Headers(
            {
                'Content-Type': 'application/json',
            }
        )
    })
}
